import { FC } from 'react';
import loadable from '@loadable/component';
import { AdvertContactsToggleButton } from '#baseMenu/components';
import { AdvertContactsLoadContext, AdvertContactsLoadContextType } from '#advertContacts/contexts';
import { AdvertContactsWrapper } from '#advertContacts/containers';

const AdvertContacts = loadable(() => import('#advertContacts/containers/AdvertContacts'), {
  resolveComponent: ({ AdvertContacts: Component }) => Component,
});

const AdvertContactsToggle: FC = () => {
  const advertContactsLoadContext: AdvertContactsLoadContextType = {
    AdvertContacts,
  };

  return (
    <AdvertContactsLoadContext value={advertContactsLoadContext}>
      <AdvertContactsToggleButton />
      <AdvertContactsWrapper />
    </AdvertContactsLoadContext>
  );
};

export { AdvertContactsToggle };
